var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * @description 请求封装
 */
import axios from 'axios';
import * as interceptors from './interceptors';
import { to } from '@tencent/vb-web-base-core';
// 旧版代码保留，避免break change破坏代码稳定性
export * from './request_old';
/**
 * 获取cgi数据的请求实例
 * @returns
 */
export var getAxiosInstance = function () {
    var _a, _b, _c, _d, _e;
    // 响应数据处理
    var instance = axios.create({
        timeout: 30000,
    });
    // 签名
    (_a = instance.interceptors.request).use.apply(_a, interceptors.sign);
    // 响应解码
    (_b = instance.interceptors.response).use.apply(_b, interceptors.decodeResponse);
    // 业务异常处理
    (_c = instance.interceptors.response).use.apply(_c, interceptors.businessError);
    // 响应异常拦截处理
    (_d = instance.interceptors.response).use.apply(_d, interceptors.errorHandler);
    // data解构出来
    (_e = instance.interceptors.response).use.apply(_e, interceptors.destructionData);
    return instance;
};
/**
 * 包括大部分接口通用的上层逻辑
 * 1. 上报
 * 2. 异常格式化
 * 3. 登录态过期等通用异常处理
 * @param params
 * @param config
 * @returns
 */
export var request = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var instance, data;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                // 入参处理
                if (typeof params === 'string') {
                    params = { url: params };
                }
                instance = getAxiosInstance();
                return [4 /*yield*/, instance(params)];
            case 1:
                data = (_a.sent()).data;
                return [2 /*return*/, data];
        }
    });
}); };
/**
 * 包括大部分接口通用的上层逻辑 的不需要catch的模式！！！！
 * @param params
 * @param config
 * @returns
 */
export var toRequest = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, to(request(params))];
    });
}); };
